export const TECHNICAL_SUPPORT_FORM_LINK = 'https://form.asana.com?hash=d419ec5cbb42bad9d11e83b7d037fe127c5605a6bf2bd64bf50267e3efde8749&id=1189032875202124'
export const REQUEST_SUPPORT_FORM_LINK = 'https://form.asana.com?hash=a7df85435dd17dd69c6db938f916bc5e9e35b45ed873c647d4c746fc8a3f2c6d&id=1142366857660361'
export const PGATLD = window.location.origin.includes('.pga.local') || window.location.origin.includes('.sandboxpga.org') ? 'sandboxpga.org' : 'pga.org'

export const medicalAndDisaster = [{
  label: 'PGA Medical and Disaster Relief Fund',
  value: '0.00',
  fund: 'RELIEF',
  removeable: true,
  hasDetail: false
}]

export const financialAssistance = [{
  label: 'PGA Financial Assistance Fund',
  value: '0.00',
  fund: 'ASSIST',
  removeable: true,
  hasDetail: false
}]

export const donationFunds = [
  ...financialAssistance,
  ...medicalAndDisaster
]
